export default "__VITE_ASSET__6d53a492__"